<template>
  <!-- Question Editor 试题dialog 20200605 14:40 Created By ZZC  -->
  <el-dialog :title="editText + '试题'" :visible.sync="dialogVisible" custom-class="lx-dialog" :close-on-click-modal="false" @open="handleOpen">
    <el-form label-width="120px" :rules="rules" :model="form" ref="form">
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell" label="考查方式" prop="way">
            <el-radio-group v-model="form.way" @change="changeType">
              <el-radio v-for="(way, index) in form.ways" :key="index + 'way'" :label="way.value">{{way.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell stem" label="题干" prop="stem">
            <quill-editor v-model="form.stem" :options="editorOption"></quill-editor>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell option" label="选项" :prop="optionProp" style="width: 100%;">
            <template v-if="form.way === '1'">
              <el-radio-group v-model="form.singleOption" style="width: calc(100% - 15px); padding: 20px 0 20px 0;">
                <el-row v-for="(opt, index) in chooseOptions" :key="index + 'opt'" style="height: 45px; line-height: 45px; border-bottom: transparent !important; width: calc(100% - 15px);">
                  <el-col>
                    <el-radio :label="opt.value">
                      {{options[index]}}
                    </el-radio>
                    <el-input style="width: calc(100% - 50px); margin-left: 10px;" v-model="opt.name" placeholder="请输入选项内容"></el-input>
                  </el-col>
                </el-row>
              </el-radio-group>
            </template>
            <template v-if="form.way === '2'">
              <el-checkbox-group v-model="form.moreOption" style="width: calc(100% - 15px); padding: 20px 0 40px 0;">
                <el-row v-for="(opt, index) in chooseOptions" :key="index + 'opt'" style="height: 45px; line-height: 45px; border-bottom: transparent !important; width: calc(100% - 15px);">
                  <el-col>
                    <el-checkbox :label="opt.value">
                      {{options[index]}}
                    </el-checkbox>
                    <el-input style="width: calc(100% - 50px); margin-left: 10px;" v-model="opt.name" placeholder="请输入选项内容"></el-input>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </template>
            <template v-if="form.way === '3'">
              <el-radio-group v-model="form.judgeOption" style="width: calc(100% - 15px); padding: 20px 0 20px 0;">
                <el-radio v-for="(opt, index) in chooseJudeOptions" :key="index + 'opt'" :label="opt.value">
                  {{judeOptions[index]}}
                </el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell" label="解析" prop="analysis">
            <el-input class="l-d-no-border" v-model="form.analysis" placeholder="请输入解析"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="small" @click="$emit('update:visible', false)">取 消</el-button>
      <lx-submit btn-size="small" btn-type="primary" :btn-disabled="isBtnDisabled" @click.native="handleSubmitEditResult('form')">确 定</lx-submit>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
// import __ from '@/util/common-utils'
import Submitting from '@/components/common/Submitting'
export default {
  props: ['visible', 'quesIdentity', 'processIdentify', 'apiIndentity'],

  components: { 'lx-submit': Submitting },

  data () {
    return {
      form: {
        way: '1',
        ways: [
          { name: '单选题', value: '1' },
          { name: '多选题', value: '2' },
          { name: '判断题', value: '3' }
        ],
        stem: '',
        singleOption: 'A',
        moreOption: ['A', 'B'],
        judgeOption: 'A',
        analysis: ''
      },
      chooseOptions: [
        { name: '', value: 'A' },
        { name: '', value: 'B' },
        { name: '', value: 'C' },
        { name: '', value: 'D' }
      ],
      chooseJudeOptions: [
        { name: '', value: 'A' },
        { name: '', value: 'B' }
      ],
      options: ['A', 'B', 'C', 'D'],
      judeOptions: ['对', '错'],
      rules: {
        way: [{ required: true, message: '请选择考查方式', trigger: 'blur' }],
        stem: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        singleOption: [{ required: true, message: '请选择答案', trigger: 'blur' }],
        moreOption: [{ required: true, message: '请选择答案', trigger: 'blur' }],
        judgeOption: [{ required: true, message: '请选择答案', trigger: 'blur' }],
        analysis: [{ required: false, message: '请输入解析', trigger: 'blur' }]
      },
      isBtnDisabled: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', {'script': 'sub'}, { 'script': 'super' }, 'formula', 'image', 'clean']
          ]
        },
        placeholder: '请输入题干'
      },
      singleOption: {
        modules: {
          toolbar: false
        },
        placeholder: '请输入选项'
      }
    }
  },

  watch: {

  },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    edit () { return this.quesIdentity.id && this.quesIdentity.edit },
    editText () { return this.quesIdentity.id && this.quesIdentity.edit ? '编辑' : '添加' },
    optionProp () {
      if (this.form.way === '1') {
        return 'singleOption'
      } else if (this.form.way === '2') {
        return 'moreOption'
      } else if (this.form.way === '3') {
        return 'judgeOption'
      }
    }
  },

  mounted () {
  },

  methods: {
    handleOpen () {
      this.isBtnDisabled = false
      if (this.edit) {
        let questionInfo = _.cloneDeep(this.quesIdentity)
        this.form.way = questionInfo.entryType
        this.form.stem = questionInfo.stem
        if (questionInfo.entryType === '1') {
          this.form.singleOption = questionInfo.answer
        } else if (questionInfo.entryType === '2') {
          this.form.moreOption = questionInfo.answer.split(',')
        } else if (questionInfo.entryType === '3') {
          this.form.judgeOption = questionInfo.answer
        }
        this.form.analysis = questionInfo.analysis
        if (!questionInfo.choices) {
          return false
        }
        for (let i = 0; i < questionInfo.choices.length; i++) {
          this.chooseOptions[i].name = questionInfo.choices[i]
        }
      } else {
        this.form = {
          way: '1',
          ways: [
            { name: '单选题', value: '1' },
            { name: '多选题', value: '2' },
            { name: '判断题', value: '3' }
          ],
          stem: '',
          singleOption: 'A',
          moreOption: ['A', 'B'],
          judgeOption: 'A',
          analysis: ''
        }
        this.chooseOptions = [
          { name: '', value: 'A' },
          { name: '', value: 'B' },
          { name: '', value: 'C' },
          { name: '', value: 'D' }
        ]
      }
    },

    changeType () {
      this.$forceUpdate()
    },

    closeDialog () {
      this.$emit('edit-result', this.form)
      this.$emit('update:visible', false)
    },

    xhrAdd () {
      let answer = null
      if (this.form.way === '1') {
        answer = this.form.singleOption
      } else if (this.form.way === '2') {
        answer = this.form.moreOption
      } else if (this.form.way === '3') {
        answer = this.form.judgeOption
      }
      let formData = {
        // projectItemId: this.apiIndentity,
        entryType: this.form.way,
        stem: this.form.stem,
        choices: this.form.way === '3' ? null : _.map(this.chooseOptions, 'name'),
        answer: answer,
        analysis: this.form.analysis
      }
      this.$xhrPost(`/tools/${this.processIdentify.id}/questions`, formData).then(rs => {
        if (rs.code === 200) {
          this.isBtnDisabled = true
          this.closeDialog()
          this.$emit('edit-result', true)
        } else {
          this.isBtnDisabled = false
        }
      })
    },

    xhrUpdate () {
      let answer = null
      if (this.form.way === '1') {
        answer = this.form.singleOption
      } else if (this.form.way === '2') {
        answer = this.form.moreOption
      } else if (this.form.way === '3') {
        answer = this.form.judgeOption
      }
      let formData = {
        entryType: this.form.way,
        stem: this.form.stem,
        choices: this.form.way === '3' ? null : _.map(this.chooseOptions, 'name'),
        answer: answer,
        score: this.form.score,
        analysis: this.form.analysis
      }
      this.$xhrPut(`/questions/${this.quesIdentity.id}`, formData, null, { allowDots: true }).then(rs => {
        if (rs.code === 200) {
          this.isBtnDisabled = true
          this.closeDialog()
          this.$emit('edit-result', true)
        } else {
          this.isBtnDisabled = false
        }
      })
    },

    // 校验
    beforeSave () {
      let stem = _.cloneDeep(this.form.stem.replace(/\s*/g, ''))
      let arr = []
      let findEle = '<p>'
      let length = 3
      let startIndex = 0
      while (stem.indexOf(findEle, startIndex) !== -1) {
        startIndex = stem.indexOf(findEle, startIndex)
        startIndex = startIndex + length
        let endIndex = stem.indexOf('</p>', startIndex)
        let content = stem.substring(startIndex, endIndex)
        if (content !== '') {
          arr.push(content)
        }
      }
      if (arr.length === 0) {
        this.$message.warning(`请输入题目题干!`)
        this.isBtnDisabled = false
        return false
      }
      if (this.form.way === '1') {
        if (this.form.singleOption === '' || this.form.singleOption === null) {
          this.$message.warning(`请为单选题选择正确答案!`)
          this.isBtnDisabled = false
          return false
        }
      }
      if (this.form.way === '2') {
        if (this.form.moreOption.length < 2) {
          this.$message.warning(`请为多选题至少选择两个正确答案!`)
          this.isBtnDisabled = false
          return false
        }
      }
      if (this.form.way === '3') {
        if (this.form.judgeOption === '') {
          this.$message.warning(`请为判断题选择正确答案!`)
          this.isBtnDisabled = false
          return false
        }
      } else if (this.form.way !== '3') {
        let choose = ''
        for (let key in this.chooseOptions) {
          choose = this.chooseOptions[key].name.replace(/\s*/g, '')
          if (choose === '') {
            this.$message.warning(`请输入选项内容!`)
            this.isBtnDisabled = false
            return false
          }
        }
      }
      return true
    },

    handleSubmitEditResult (formName) {
      this.isBtnDisabled = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.beforeSave()) {
            this.edit ? this.xhrUpdate() : this.xhrAdd()
          }
        } else {
          this.$message.error('请检查输入')
          this.isBtnDisabled = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.is-success /deep/ .el-input__inner { border-color: #dcdfe6; }
/deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow { min-height: 130px; }
.stem /deep/ .el-form-item__error { top: 85% !important; }
.option /deep/ .el-form-item__error { top: 90% !important; }
.option /deep/ .el-input__inner { border-color: #dcdfe6; }
</style>



// WEBPACK FOOTER //
// src/components/teaching/DisassemblyQuesEditor.vue